<template>
    <div v-if="showNotice && !mediaAccess" class="main-notice main-notice--warning">
        <div class="page__container">
            <div class="cookie-notice cookie-notice--warning">
                <div class="cookie-notice__info">
                    <p>
                        Вы не включили микрофон или веб-камеру. Пожалуйста, проверьте Ваши настройки<br>
                        <a :href="'/pdf/hardware_setup_information.pdf'" target="_blank">Инструкция по настройке оборудования</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../consultation/Room/store/room-store';
    import {mapState} from 'vuex';

    export default {
        store,
        name: "ConsultationWarning",
        data() {
            return {
                showNotice : true
            }
        },
        computed: {
            ...mapState('conference', [
                'mediaAccess'
            ])
        },
        methods: {
            closeNotice() {
                this.showNotice = false;
            }
        }
    }
</script>
